import { Link } from "react-router";
import Header from "../components/Header";
import Footer from "../components/Footer";
import SEO from "../components/SEO";

export default function NotFound() {
  return (
    <div className="bg-white min-h-screen">
      <SEO
        title="Page Not Found - Unpatterned"
        description="The page you're looking for doesn't exist. Return to Unpatterned to continue building cognitive depth."
        url="https://unpatterned.org/404"
      />
      <Header />

      <section className="pt-40 pb-32 px-6">
        <div className="max-w-4xl mx-auto text-center">
          <div className="mb-8">
            <span className="font-['DM_Serif_Display',serif] text-8xl md:text-9xl text-[#184b9d]/20">
              404
            </span>
          </div>
          
          <h1 className="font-['DM_Serif_Display',serif] text-4xl md:text-6xl text-[#050e1d] mb-6 leading-tight">
            This path leads nowhere
          </h1>
          
          <p className="font-['Manrope',sans-serif] text-lg md:text-xl text-[#050e1d]/70 mb-12 leading-relaxed max-w-2xl mx-auto">
            The page you're looking for doesn't exist. Perhaps it's time to explore a different direction.
          </p>

          <div className="flex flex-col sm:flex-row gap-4 justify-center mb-16">
            <Link 
              to="/"
              className="bg-[#184b9d] text-white px-8 py-4 rounded-lg font-['Manrope',sans-serif] font-medium text-lg hover:bg-[#1e8eaf] transition-all hover:scale-105 inline-block"
            >
              Return Home
            </Link>
            <Link 
              to="/blog"
              className="bg-white border-2 border-[#184b9d] text-[#184b9d] px-8 py-4 rounded-lg font-['Manrope',sans-serif] font-medium text-lg hover:bg-[#184b9d]/5 transition-all inline-block"
            >
              Read Latest Updates
            </Link>
          </div>

          {/* Quick Links */}
          <div className="pt-12 border-t border-[rgba(5,14,26,0.1)]">
            <p className="font-['Manrope',sans-serif] text-sm text-[#050e1d]/50 mb-6">
              You might be looking for:
            </p>
            <div className="flex flex-wrap gap-4 justify-center">
              <span className="text-[#050e1d]/20">•</span>
              <a 
                href="https://discord.gg/unpatterned"
                target="_blank"
                rel="noopener noreferrer"
                className="font-['Manrope',sans-serif] text-[#184b9d] hover:underline"
              >
                Discord Community
              </a>
              <span className="text-[#050e1d]/20">•</span>
              <a 
                href="https://unpatterned.substack.com"
                target="_blank"
                rel="noopener noreferrer"
                className="font-['Manrope',sans-serif] text-[#184b9d] hover:underline"
              >
                Substack
              </a>
              <span className="text-[#050e1d]/20">•</span>
              <Link 
                to="/blog"
                className="font-['Manrope',sans-serif] text-[#184b9d] hover:underline"
              >
                Blog
              </Link>
            </div>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
}
